module.exports = __webpack_public_path__ + "static/julian.3a1326ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/contributors/julian.png
// module id = ./src/assets/graphics/contributors/julian.png
// module chunks = 1